var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.23 25C19.8574 25 25.23 19.6274 25.23 13C25.23 6.37258 19.8574 1 13.23 1C6.60256 1 1.22998 6.37258 1.22998 13C1.22998 19.6274 6.60256 25 13.23 25Z",
    stroke: "#7B7B7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.23 17C15.9914 17 18.23 14.7614 18.23 12C18.23 9.23858 15.9914 7 13.23 7C10.4686 7 8.22998 9.23858 8.22998 12C8.22998 14.7614 10.4686 17 13.23 17Z",
    stroke: "#7B7B7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20483 21.9218C5.9581 20.4408 7.10648 19.1971 8.52287 18.3284C9.93926 17.4598 11.5684 17 13.2299 17C14.8915 17 16.5206 17.4598 17.937 18.3284C19.3534 19.1971 20.5018 20.4407 21.2551 21.9217",
    stroke: "#7B7B7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3dff58d74c3298b943742fad96ac00f6.svg";
export { ForwardRef as ReactComponent };